import React from 'react';

import Link from '@buyside/components/presentation/Link/link';
import FundProfile from '../FundProfile/fundProfile';
import FundRecommendationHeader, {
  FundRecommendationType
} from '@buyside/components/presentation/Feed/FundRecommendationHeader/fundRecommendationHeader';

import { employerProfileVanityUrl, employerProfilesUrl } from '@buyside/util/urlHelper';
import {
  ActivityFeedEmployerProfileFragment,
  FundProfileCardFragment
} from '@interfaces/graphql-typings';
import { FeedItemComponentType } from '@interfaces/feed/feedItems';

import styles from './newFundStyles.scss';

export const NewFund: React.FC<{
  fundProfile: ActivityFeedEmployerProfileFragment;
  recommendation: FundRecommendationType;
  recommendedFundProfile: FundProfileCardFragment;
} & FeedItemComponentType> = ({
  fundProfile,
  recommendation,
  recommendedFundProfile
}): React.ReactElement | null => {
  const { name, vanityLink } = fundProfile;

  if (!vanityLink || name) return null;

  return (
    <div className={styles.newFund}>
      <div className={styles.activityText}>
        <Link to={employerProfileVanityUrl(vanityLink)}>{name}</Link>
        &nbsp;has just joined SumZero&nbsp;
        <Link to={employerProfilesUrl()}>Cap Intro</Link>.
      </div>
      {recommendation && (
        <FundRecommendationHeader
          fundRecommendation={recommendation}
          recommendedFundProfile={recommendedFundProfile}
        />
      )}
      <FundProfile fundProfile={fundProfile} />
    </div>
  );
};

export default NewFund;
